import styles from './AppHeader.module.css'
import smallLogo from './../../../image/logo_mini.png'
import smallLogo05 from './../../../image/logo_mini05.png'

import logoMain from './images/ic_logo_main_mini.png'
import logoMain2x from './images/ic_logo_main_mini2x.png'
import bicycle from './images/ic_bicycle_mini.png'
import bicycle2x from './images/ic_bicycle_mini2x.png'
import run from './images/ic_run_mini.png'
import run2x from './images/ic_run_mini2x.png'
import skis from './images/ic_skis_mini.png'
import skis2x from './images/ic_skis_mini2x.png'
import swiming from './images/ic_swiming_mini.png'
import swiming2x from './images/ic_swiming_mini2x.png'
import swiming185 from './images/ic_swiming185_mini.png'
import swiming1852x from './images/ic_swiming185_mini2x.png'
import walk from './images/ic_walk_mini.png'
import walk2x from './images/ic_walk_mini2x.png'
import { useAppSelector } from '../../../hooks/redux'
import { useEffect, useRef, useState } from 'react'
import { ActivityType } from '../../../models/commonModels'
export const AppHeaderSmall = ({isMaim}:{isMaim:boolean}) =>{
    const activityTab = useAppSelector(state=>state.appStore.activity_type)
    const imgRefmobile = useRef<HTMLImageElement|null>(null)
    const [currentHeaderImage, setCurrentHeaderImage]=useState(logoMain)//десктоп
    const [currentHeaderImage2x, setCurrentHeaderImage2x]=useState(logoMain)//мобилка
    const changeCurrentHeaderImage=(res:string,res2x:string)=>{
        if(imgRefmobile.current!=null){
            imgRefmobile.current.style.transform='scale(0.9)'
            imgRefmobile.current.style.opacity = "0.7";
            setTimeout(function() {
            if(imgRefmobile.current!=null){
                imgRefmobile.current.style.transform='scale(1)'
                imgRefmobile.current.style.opacity='1'
                setCurrentHeaderImage(res)
                setCurrentHeaderImage2x(res2x)
            }
        }, 250);
        }else{
            setCurrentHeaderImage(res)
            setCurrentHeaderImage2x(res2x)
        }
    }

    useEffect(()=>{
                    switch(activityTab){
                        case ActivityType.RUN : 
                            changeCurrentHeaderImage(run,run2x)
                            break;
                        case ActivityType.BICYCLE : 
                            changeCurrentHeaderImage(bicycle,bicycle2x)
                            break;
                        case ActivityType.SKIS : 
                            changeCurrentHeaderImage(skis,skis2x)
                            break;  
                        case ActivityType.SWIMMING : 
                            changeCurrentHeaderImage(swiming,swiming2x)
                            break;
                        case ActivityType.WALK : 
                            changeCurrentHeaderImage(walk,walk2x)
                            break;       
                        case ActivityType.SWIMMING_185 : 
                            changeCurrentHeaderImage(swiming185,swiming1852x)
                            break;               
                    }
                },[activityTab])
    return(
        <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
            <div style={{position:"fixed", top:"0", width:"100%", zIndex:"998", backgroundColor:"white", display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
                <span className={styles.app_header_logo}>
                    {isMaim==true&&<img src={logoMain2x}/>}
                    {isMaim==false&&<img src={currentHeaderImage}/>}
                    </span>
                <div className={styles.app_header_logo_mobile}>
                     {isMaim==true&&<img src={logoMain}/>}
                    {isMaim==false&&<img src={currentHeaderImage} style={{width:"100%",height:"auto"}} ref={imgRefmobile}/>}
                </div>
            </div>
            {/* как по другому быстро прилепить заголовок я не знаю */}
            <div style={{opacity:"0"}}>
                <span className={styles.app_header_logo}>
                    {isMaim==true&&<img src={logoMain2x}/>}
                    {isMaim==false&&<img src={currentHeaderImage}/>}
                    </span>
                <div className={styles.app_header_logo_mobile}>
                    {isMaim==true&&<img src={logoMain}/>}
                    {isMaim==false&&<img src={currentHeaderImage} style={{width:"100%",height:"auto"}}/>}
                </div>
            </div>
        </div>
    )
}